// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paysendCard-module_paysendCardContainer__HtwNP {
    min-width: 249px;
}

/*
 * The card is a liquid-glass panel: the <Glass> material (@samasante/liquid-glass)
 * writes \`backdrop-filter\` inline onto THIS element, so everything here has to keep
 * the backdrop reachable.
 *
 *  - The fill must never be fully opaque. An opaque colour, gradient or photo paints
 *    over the page the lens is refracting and the effect disappears (the library warns
 *    about exactly this). The resting fill is therefore clear glass, and the only thing
 *    on it is the ic_psCardBalance artwork, which is itself a 40%-alpha motif.
 *  - Every state moves the fill COLOUR, never \`opacity\`/\`filter\`/\`transform\`, each of
 *    which would start a new backdrop root and blank the lens. For the same reason the
 *    state layers below use \`background-color\`/\`background-image\` longhands rather than
 *    the \`background\` shorthand, which would reset the artwork.
 *  - The frozen/expired photo lives on ::before as a translucent overlay rather than in
 *    \`background\`, and the inactive dimming on ::after.
 *  - \`display: flex\` is repeated as an inline style in PaysendCard.tsx, because
 *    <Glass> sets \`display: inline-block\` inline to shrink-wrap button-sized content.
 */
.paysendCard-module_cardContainer__NfYfV {
    position: relative;
    overflow: hidden;
    padding: 12px 12px 10px 12px;
    background-color: var(--paysend-card-bg);

    /*
     * \`100% 100%\` rather than cover/contain: the artwork is 314x224 (ratio 1.4) on a 1.6
     * card, so \`cover\` would crop the top and bottom of the globe and \`contain\` would
     * leave bars down the sides. Stretching fills the card AND keeps the whole motif on
     * it, and the motif is symmetrical enough that the ~14% horizontal scale doesn't read.
     */
    background-image: var(--card-background-image);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%;
    aspect-ratio: 1.6;
    display: flex;
    box-sizing: border-box;
    border-radius: 12px;
    cursor: pointer;
    margin: 0 auto;
    width: 249px;

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background-color: var(--paysend-card-bg-hovered);
        }
    }
    &:active {
        background-color: var(--paysend-card-bg-pressed);
    }

    @media screen and (min-width: 392px) {
        max-width: 360px;
    }

    &::before {
        display: none;
    }
}

/*
 * The crisp content layer. <Glass> emits absolutely positioned layers of its own —
 * the brightness veil BEFORE the children, the rim light after — and a positioned
 * box always paints above static in-flow content, so the content is positioned too
 * to clear the veil. Being earlier in tree order than the rim light and ::after, it
 * still sits under both, which is where the content was before the effect.
 */
.paysendCard-module_cardSurface__U9MvX {
    position: relative;
    display: flex;
    flex: 1;
    min-width: 0;
    flex-direction: column;
    justify-content: space-between;
}

.paysendCard-module_cardAnimationZoomOut__JJsPR {
    animation: paysendCard-module_CardZoomOut__gUdU1 0.3s forwards;
}

.paysendCard-module_topLayoutOnCardScreen__pmjI5 .paysendCard-module_cardAnimationZoomIn__W1t9v {
    animation: paysendCard-module_CardZoomIn__qqnf_ 0.3s forwards;
}

/*
 * Frozen / expired artwork. It sits on a translucent overlay instead of the card's
 * \`background\` so the glass still reads through it — an opaque \`cover\` image would
 * hide the refraction completely. The overlay is the first positioned child, so it
 * paints below .cardSurface and cannot cover the PAN or the status tag.
 */
.paysendCard-module_cardContainer__NfYfV.paysendCard-module_frozen__uLNCv::before,
.paysendCard-module_cardContainer__NfYfV.paysendCard-module_expired__BB1_i::before {
    display: block;
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    pointer-events: none;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    opacity: 0.72;
}
.paysendCard-module_cardContainer__NfYfV.paysendCard-module_expired__BB1_i::before,
.paysendCard-module_cardContainer__NfYfV.paysendCard-module_frozen__uLNCv::before {
    background-color: var(--paysend-card-frozen-overlay);
}

.paysendCard-module_frozenFrost__ZaLV4 {
    position: absolute;
    inset: 0;
    border-radius: inherit;
    pointer-events: none;
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px); /* Safari */
}

.paysendCard-module_cardContainer__NfYfV.paysendCard-module_firstRender__u3zJv {
    animation: none;
}

.paysendCard-module_cardContainer__NfYfV.paysendCard-module_cardContainerOnCardScreen__ovDWu {
    padding: 24px;
    cursor: default;

    @media screen and (min-width: 392px) {
        width: 100%;
    }
}

.paysendCard-module_cardContainer__NfYfV.paysendCard-module_cardContainerInactive__KPwsY::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    pointer-events: none;
}

.paysendCard-module_cardRow__BLfQS {
    display: flex;
    align-items: center;
}

.paysendCard-module_cardRow__BLfQS.paysendCard-module_spaceBetween__pswwV {
    justify-content: space-between;
}
.paysendCard-module_cardRow__BLfQS.paysendCard-module_flexEnd__Gu9jm {
    justify-content: flex-end;
}

.paysendCard-module_cardRow__BLfQS.paysendCard-module_topAlignment__lUMpL {
    align-items: start;
}

.paysendCard-module_psIconContainer__aWw36 {
    svg {
        max-width: 100%;
        max-height: 100%;
    }
}

.paysendCard-module_psIconContainer__aWw36.paysendCard-module_psIconContainerInactive__mjJZH {
    opacity: 0.48;
}

/*
 * The one thing the frozen frost must NOT blur, so it is the only content lifted
 * out of .cardSurface's paint order. (It now also paints above
 * .cardContainerInactive::after — harmless while that layer has no background.)
 */
.paysendCard-module_tagContainer__nmTCb {
    display: inline-flex;
    position: relative;
    z-index: 1;
}

.paysendCard-module_paymentIconsRow__sW6Wg {
    display: flex;
    column-gap: 10px;
}

.paysendCard-module_paymentIconsRow__sW6Wg.paysendCard-module_paymentIconsRowCardScreen__REbTs {
    column-gap: 20px;
}

.paysendCard-module_iconContainer__X5cBi {
    svg {
        max-width: 100%;
    }
}

.paysendCard-module_cardScreen__c0dc8 {
    position: fixed;
    width: 100%;
    height: 100%;
    flex-direction: column;
    display: flex;
    z-index: -1;
    opacity: 0;
    background: var(--grey_8_lc);
}

.paysendCard-module_cardScreen__c0dc8.paysendCard-module_cardScreenOnCardScreen__dgPtm {
    z-index: var(--zindex-modal-index);
    opacity: 1;
}

.paysendCard-module_layoutContainer__CcjwS {
    display: flex;
    flex-direction: column;
    flex: 1;
}

.paysendCard-module_topLayout__iMe1J {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 64px 16px 16px 16px;
    /* \`--top-layout-background\` is set inline from \`options.backgroundImage\`; without it the flat surface colour is used. */
    background: var(--top-layout-background, var(--grey_8_lc));

    @media screen and (max-height: 634px) {
        padding: 24px 16px 16px 16px;
    }
}

.paysendCard-module_layoutInner__55eZi {
    width: 100%;
    max-width: 448px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
}

.paysendCard-module_textContainer__Ura4G {
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;

    @media screen and (max-height: 634px) {
        flex: 0;
    }
}

.paysendCard-module_bottomLayout__qPrtt {
    background: var(--white);
    padding: 0 16px 29px 16px;
    position: relative;
    animation: paysendCard-module_BottomSlideOut__b73pp 0.3s forwards;
}

.paysendCard-module_bottomLayout__qPrtt.paysendCard-module_bottomLayoutCardScreen__g4Xj5 {
    animation: paysendCard-module_BottomSlideIn__Gk7qY 0.3s forwards;
}

.paysendCard-module_cardBalanceButtons___mu_m {
    display: flex;
    justify-content: center;
    margin-top: 8px;
    margin-bottom: 24px;
}

.paysendCard-module_cardBalanceButtons___mu_m.paysendCard-module_cardBalanceButtonsHasButtonRow__BGMGO {
    margin-left: -24px;
    margin-right: -24px;
}

.paysendCard-module_copyButton__Oj54F {
    padding: 16px 24px;
    border: none;
    background: none;
    outline: none;
    cursor: pointer;
    width: 100%;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (hover: hover) and (pointer: fine) {
        &:hover {
            background: var(--purple_16_tr);
        }
    }

    &:active,
    &:focus-visible {
        background: var(--purple_8_tr);
    }
}

.paysendCard-module_copyButtonIcon__RljqP {
    margin-left: 8px;
    flex-shrink: 0;
}

.paysendCard-module_addWalletButton__f0QN8 {
    padding: 0;
    border: none;
    background: none;
    outline: none;
    cursor: pointer;
    margin-top: 24px;
}

.paysendCard-module_cardBalanceDone__DAB_4 {
    display: flex;
    justify-content: center;
}

@keyframes paysendCard-module_CardZoomIn__qqnf_ {
    0% {
        width: 249px;
    }
    100% {
        width: 361px;
    }
}

@keyframes paysendCard-module_CardZoomOut__gUdU1 {
    0% {
        width: 361px;
    }
    100% {
        width: 249px;
    }
}

@keyframes paysendCard-module_BottomSlideIn__Gk7qY {
    0% {
        bottom: -100%;
    }
    100% {
        bottom: 0;
    }
}

@keyframes paysendCard-module_BottomSlideOut__b73pp {
    0% {
        bottom: 0;
    }
    100% {
        bottom: -100%;
    }
}

@keyframes paysendCard-module_HideCardScreen__fPDPr {
    0% {
        z-index: 1;
        opacity: 1;
        background: var(--grey_8_lc);
    }
    90% {
        z-index: 1;
        /*opacity: 1;*/
        background: var(--grey_8_lc);
    }
    100% {
        z-index: -1;
        opacity: 0;
        background: transparent;
    }
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Card/CardBalance/paysendCard.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;;AAEA;;;;;;;;;;;;;;;;;EAiBE;AACF;IACI,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,wCAAwC;;IAExC;;;;;MAKE;IACF,8CAA8C;IAC9C,4BAA4B;IAC5B,kCAAkC;IAClC,0BAA0B;IAC1B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,YAAY;;IAEZ;QACI;YACI,gDAAgD;QACpD;IACJ;IACA;QACI,gDAAgD;IACpD;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;;;;;;EAME;AACF;IACI,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,8DAAoC;AACxC;;AAEA;IACI,6DAAmC;AACvC;;AAEA;;;;;EAKE;AACF;;IAEI,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,oBAAoB;IACpB,4BAA4B;IAC5B,kCAAkC;IAClC,sBAAsB;IACtB,aAAa;AACjB;AACA;;IAEI,oDAAoD;AACxD;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,oBAAoB;IACpB,0BAA0B;IAC1B,kCAAkC,EAAE,WAAW;AACnD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;;IAEf;QACI,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;EAIE;AACF;IACI,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,aAAa;IACb,WAAW;IACX,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,kCAAkC;IAClC,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,4BAA4B;IAC5B,wHAAwH;IACxH,0DAA0D;;IAE1D;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,OAAO;AACX;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,uBAAuB;IACvB,mBAAmB;;IAEnB;QACI,OAAO;IACX;AACJ;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,iEAAuC;AAC3C;;AAEA;IACI,gEAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B;QACI;YACI,+BAA+B;QACnC;IACJ;;IAEA;;QAEI,8BAA8B;IAClC;AACJ;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;IACA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;QACI,SAAS;IACb;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,UAAU;QACV,4BAA4B;IAChC;IACA;QACI,UAAU;QACV,cAAc;QACd,4BAA4B;IAChC;IACA;QACI,WAAW;QACX,UAAU;QACV,uBAAuB;IAC3B;AACJ","sourcesContent":[".paysendCardContainer {\n    min-width: 249px;\n}\n\n/*\n * The card is a liquid-glass panel: the <Glass> material (@samasante/liquid-glass)\n * writes `backdrop-filter` inline onto THIS element, so everything here has to keep\n * the backdrop reachable.\n *\n *  - The fill must never be fully opaque. An opaque colour, gradient or photo paints\n *    over the page the lens is refracting and the effect disappears (the library warns\n *    about exactly this). The resting fill is therefore clear glass, and the only thing\n *    on it is the ic_psCardBalance artwork, which is itself a 40%-alpha motif.\n *  - Every state moves the fill COLOUR, never `opacity`/`filter`/`transform`, each of\n *    which would start a new backdrop root and blank the lens. For the same reason the\n *    state layers below use `background-color`/`background-image` longhands rather than\n *    the `background` shorthand, which would reset the artwork.\n *  - The frozen/expired photo lives on ::before as a translucent overlay rather than in\n *    `background`, and the inactive dimming on ::after.\n *  - `display: flex` is repeated as an inline style in PaysendCard.tsx, because\n *    <Glass> sets `display: inline-block` inline to shrink-wrap button-sized content.\n */\n.cardContainer {\n    position: relative;\n    overflow: hidden;\n    padding: 12px 12px 10px 12px;\n    background-color: var(--paysend-card-bg);\n\n    /*\n     * `100% 100%` rather than cover/contain: the artwork is 314x224 (ratio 1.4) on a 1.6\n     * card, so `cover` would crop the top and bottom of the globe and `contain` would\n     * leave bars down the sides. Stretching fills the card AND keeps the whole motif on\n     * it, and the motif is symmetrical enough that the ~14% horizontal scale doesn't read.\n     */\n    background-image: var(--card-background-image);\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: 100% 100%;\n    aspect-ratio: 1.6;\n    display: flex;\n    box-sizing: border-box;\n    border-radius: 12px;\n    cursor: pointer;\n    margin: 0 auto;\n    width: 249px;\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background-color: var(--paysend-card-bg-hovered);\n        }\n    }\n    &:active {\n        background-color: var(--paysend-card-bg-pressed);\n    }\n\n    @media screen and (min-width: 392px) {\n        max-width: 360px;\n    }\n\n    &::before {\n        display: none;\n    }\n}\n\n/*\n * The crisp content layer. <Glass> emits absolutely positioned layers of its own —\n * the brightness veil BEFORE the children, the rim light after — and a positioned\n * box always paints above static in-flow content, so the content is positioned too\n * to clear the veil. Being earlier in tree order than the rim light and ::after, it\n * still sits under both, which is where the content was before the effect.\n */\n.cardSurface {\n    position: relative;\n    display: flex;\n    flex: 1;\n    min-width: 0;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.cardAnimationZoomOut {\n    animation: CardZoomOut 0.3s forwards;\n}\n\n.topLayoutOnCardScreen .cardAnimationZoomIn {\n    animation: CardZoomIn 0.3s forwards;\n}\n\n/*\n * Frozen / expired artwork. It sits on a translucent overlay instead of the card's\n * `background` so the glass still reads through it — an opaque `cover` image would\n * hide the refraction completely. The overlay is the first positioned child, so it\n * paints below .cardSurface and cannot cover the PAN or the status tag.\n */\n.cardContainer.frozen::before,\n.cardContainer.expired::before {\n    display: block;\n    content: '';\n    position: absolute;\n    inset: 0;\n    border-radius: inherit;\n    pointer-events: none;\n    background-repeat: no-repeat;\n    background-position: center center;\n    background-size: cover;\n    opacity: 0.72;\n}\n.cardContainer.expired::before,\n.cardContainer.frozen::before {\n    background-color: var(--paysend-card-frozen-overlay);\n}\n\n.frozenFrost {\n    position: absolute;\n    inset: 0;\n    border-radius: inherit;\n    pointer-events: none;\n    backdrop-filter: blur(2px);\n    -webkit-backdrop-filter: blur(2px); /* Safari */\n}\n\n.cardContainer.firstRender {\n    animation: none;\n}\n\n.cardContainer.cardContainerOnCardScreen {\n    padding: 24px;\n    cursor: default;\n\n    @media screen and (min-width: 392px) {\n        width: 100%;\n    }\n}\n\n.cardContainer.cardContainerInactive::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    border-radius: inherit;\n    pointer-events: none;\n}\n\n.cardRow {\n    display: flex;\n    align-items: center;\n}\n\n.cardRow.spaceBetween {\n    justify-content: space-between;\n}\n.cardRow.flexEnd {\n    justify-content: flex-end;\n}\n\n.cardRow.topAlignment {\n    align-items: start;\n}\n\n.psIconContainer {\n    svg {\n        max-width: 100%;\n        max-height: 100%;\n    }\n}\n\n.psIconContainer.psIconContainerInactive {\n    opacity: 0.48;\n}\n\n/*\n * The one thing the frozen frost must NOT blur, so it is the only content lifted\n * out of .cardSurface's paint order. (It now also paints above\n * .cardContainerInactive::after — harmless while that layer has no background.)\n */\n.tagContainer {\n    display: inline-flex;\n    position: relative;\n    z-index: 1;\n}\n\n.paymentIconsRow {\n    display: flex;\n    column-gap: 10px;\n}\n\n.paymentIconsRow.paymentIconsRowCardScreen {\n    column-gap: 20px;\n}\n\n.iconContainer {\n    svg {\n        max-width: 100%;\n    }\n}\n\n.cardScreen {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    flex-direction: column;\n    display: flex;\n    z-index: -1;\n    opacity: 0;\n    background: var(--grey_8_lc);\n}\n\n.cardScreen.cardScreenOnCardScreen {\n    z-index: var(--zindex-modal-index);\n    opacity: 1;\n}\n\n.layoutContainer {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n.topLayout {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    padding: 64px 16px 16px 16px;\n    /* `--top-layout-background` is set inline from `options.backgroundImage`; without it the flat surface colour is used. */\n    background: var(--top-layout-background, var(--grey_8_lc));\n\n    @media screen and (max-height: 634px) {\n        padding: 24px 16px 16px 16px;\n    }\n}\n\n.layoutInner {\n    width: 100%;\n    max-width: 448px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    flex: 1;\n}\n\n.textContainer {\n    margin-top: 16px;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    justify-content: center;\n    align-items: center;\n\n    @media screen and (max-height: 634px) {\n        flex: 0;\n    }\n}\n\n.bottomLayout {\n    background: var(--white);\n    padding: 0 16px 29px 16px;\n    position: relative;\n    animation: BottomSlideOut 0.3s forwards;\n}\n\n.bottomLayout.bottomLayoutCardScreen {\n    animation: BottomSlideIn 0.3s forwards;\n}\n\n.cardBalanceButtons {\n    display: flex;\n    justify-content: center;\n    margin-top: 8px;\n    margin-bottom: 24px;\n}\n\n.cardBalanceButtons.cardBalanceButtonsHasButtonRow {\n    margin-left: -24px;\n    margin-right: -24px;\n}\n\n.copyButton {\n    padding: 16px 24px;\n    border: none;\n    background: none;\n    outline: none;\n    cursor: pointer;\n    width: 100%;\n    text-align: left;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    @media (hover: hover) and (pointer: fine) {\n        &:hover {\n            background: var(--purple_16_tr);\n        }\n    }\n\n    &:active,\n    &:focus-visible {\n        background: var(--purple_8_tr);\n    }\n}\n\n.copyButtonIcon {\n    margin-left: 8px;\n    flex-shrink: 0;\n}\n\n.addWalletButton {\n    padding: 0;\n    border: none;\n    background: none;\n    outline: none;\n    cursor: pointer;\n    margin-top: 24px;\n}\n\n.cardBalanceDone {\n    display: flex;\n    justify-content: center;\n}\n\n@keyframes CardZoomIn {\n    0% {\n        width: 249px;\n    }\n    100% {\n        width: 361px;\n    }\n}\n\n@keyframes CardZoomOut {\n    0% {\n        width: 361px;\n    }\n    100% {\n        width: 249px;\n    }\n}\n\n@keyframes BottomSlideIn {\n    0% {\n        bottom: -100%;\n    }\n    100% {\n        bottom: 0;\n    }\n}\n\n@keyframes BottomSlideOut {\n    0% {\n        bottom: 0;\n    }\n    100% {\n        bottom: -100%;\n    }\n}\n\n@keyframes HideCardScreen {\n    0% {\n        z-index: 1;\n        opacity: 1;\n        background: var(--grey_8_lc);\n    }\n    90% {\n        z-index: 1;\n        /*opacity: 1;*/\n        background: var(--grey_8_lc);\n    }\n    100% {\n        z-index: -1;\n        opacity: 0;\n        background: transparent;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paysendCardContainer": `paysendCard-module_paysendCardContainer__HtwNP`,
	"cardContainer": `paysendCard-module_cardContainer__NfYfV`,
	"cardSurface": `paysendCard-module_cardSurface__U9MvX`,
	"cardAnimationZoomOut": `paysendCard-module_cardAnimationZoomOut__JJsPR`,
	"CardZoomOut": `paysendCard-module_CardZoomOut__gUdU1`,
	"topLayoutOnCardScreen": `paysendCard-module_topLayoutOnCardScreen__pmjI5`,
	"cardAnimationZoomIn": `paysendCard-module_cardAnimationZoomIn__W1t9v`,
	"CardZoomIn": `paysendCard-module_CardZoomIn__qqnf_`,
	"frozen": `paysendCard-module_frozen__uLNCv`,
	"expired": `paysendCard-module_expired__BB1_i`,
	"frozenFrost": `paysendCard-module_frozenFrost__ZaLV4`,
	"firstRender": `paysendCard-module_firstRender__u3zJv`,
	"cardContainerOnCardScreen": `paysendCard-module_cardContainerOnCardScreen__ovDWu`,
	"cardContainerInactive": `paysendCard-module_cardContainerInactive__KPwsY`,
	"cardRow": `paysendCard-module_cardRow__BLfQS`,
	"spaceBetween": `paysendCard-module_spaceBetween__pswwV`,
	"flexEnd": `paysendCard-module_flexEnd__Gu9jm`,
	"topAlignment": `paysendCard-module_topAlignment__lUMpL`,
	"psIconContainer": `paysendCard-module_psIconContainer__aWw36`,
	"psIconContainerInactive": `paysendCard-module_psIconContainerInactive__mjJZH`,
	"tagContainer": `paysendCard-module_tagContainer__nmTCb`,
	"paymentIconsRow": `paysendCard-module_paymentIconsRow__sW6Wg`,
	"paymentIconsRowCardScreen": `paysendCard-module_paymentIconsRowCardScreen__REbTs`,
	"iconContainer": `paysendCard-module_iconContainer__X5cBi`,
	"cardScreen": `paysendCard-module_cardScreen__c0dc8`,
	"cardScreenOnCardScreen": `paysendCard-module_cardScreenOnCardScreen__dgPtm`,
	"layoutContainer": `paysendCard-module_layoutContainer__CcjwS`,
	"topLayout": `paysendCard-module_topLayout__iMe1J`,
	"layoutInner": `paysendCard-module_layoutInner__55eZi`,
	"textContainer": `paysendCard-module_textContainer__Ura4G`,
	"bottomLayout": `paysendCard-module_bottomLayout__qPrtt`,
	"BottomSlideOut": `paysendCard-module_BottomSlideOut__b73pp`,
	"bottomLayoutCardScreen": `paysendCard-module_bottomLayoutCardScreen__g4Xj5`,
	"BottomSlideIn": `paysendCard-module_BottomSlideIn__Gk7qY`,
	"cardBalanceButtons": `paysendCard-module_cardBalanceButtons___mu_m`,
	"cardBalanceButtonsHasButtonRow": `paysendCard-module_cardBalanceButtonsHasButtonRow__BGMGO`,
	"copyButton": `paysendCard-module_copyButton__Oj54F`,
	"copyButtonIcon": `paysendCard-module_copyButtonIcon__RljqP`,
	"addWalletButton": `paysendCard-module_addWalletButton__f0QN8`,
	"cardBalanceDone": `paysendCard-module_cardBalanceDone__DAB_4`,
	"HideCardScreen": `paysendCard-module_HideCardScreen__fPDPr`
};
export default ___CSS_LOADER_EXPORT___;
